module.exports = __webpack_public_path__ + "img/plus.01e7f744.png";